exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".markerTable[data-v-66085a66]  .el-checkbox{margin:0!important}.markerTable .el-table td[data-v-66085a66],.markerTable[data-v-66085a66]  .el-table th.is-leaf{border:none!important}", ""]);

// exports
